import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';
import { UtilService } from '../util/util.service';
import { Device, IDevice, IDeviceRequest } from '../../models/device.model';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    private utilService: UtilService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR create                               */
  /* -------------------------------------------------------------------------- */
  // region create
  async create(
    device: IDeviceRequest
  ): Promise<Device | undefined> {

    let newDevice: Device | undefined;

    const urlApi = `${environment.urlApi}/devices`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse<{ device: IDevice }>>(
        (resolve, reject) => {
          this.http.post<IServerResponse<{ device: IDevice }>>(
            urlApi,
            device,
            {
              headers
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ device: IDevice }>
              ) => resolve(
                new ServerResponse<{ device: IDevice }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 201) {
        newDevice = new Device(response.data!.device);
      } else {
        console.log('Error al registrar dispositivo: ', response.message);
      }

    } catch(error) {
      console.log(error);
    }

    return newDevice;

  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR get                                 */
  /* -------------------------------------------------------------------------- */
  // region get
  async get(
    deviceId: string
  ): Promise<Device | undefined> {

    let currentDevice: Device | undefined;

    const urlApi = `${environment.urlApi}/devices/${deviceId}`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse<{ device: IDevice }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ device: IDevice }>>(
            urlApi,
            {
              headers
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ device: IDevice }>
              ) => resolve(
                new ServerResponse<{ device: IDevice }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        currentDevice = new Device(response.data!.device);
      } else {
        console.log('Error al obtener dispositivo: ', response.message);
      }

    } catch(error) {
      console.log(error);
    }

    return currentDevice;

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR update                               */
  /* -------------------------------------------------------------------------- */
  // region update
  async update(
    deviceId: string,
    device: IDeviceRequest
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/devices/${deviceId}`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.put<IServerResponse>(
            urlApi,
            device,
            {
              headers
            }
          ).subscribe({
            next: (
                response: IServerResponse
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;
      } else {
        console.log('Error al actualizar dispositivo: ', response.message);
      }

    } catch(error) {
      console.log(error);
    }

    return flag;

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR delete                               */
  /* -------------------------------------------------------------------------- */
  // region delete
  async delete(
    deviceId: string
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/devices/${deviceId}`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.delete<IServerResponse>(
            urlApi,
            {
              headers
            }
          ).subscribe({
            next: (
                response: IServerResponse
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;
      } else {
        console.log('Error al eliminar dispositivo: ', response.message);
      }

    } catch(error) {
      console.log(error);
    }

    return flag;

  }

}
